// Google Analytics 4 — načíta sa LEN ak používateľ udelil súhlas s analytickými cookies.
// GDPR: žiadny tracking pred consent + anonymizácia IP.

const GA_ID = 'G-LV5MGBKMFJ';
const STORAGE_KEY = 'cookie_consent';
const COOKIE_VERSION = 'v1.0';

let initialized = false;

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

interface CookiePrefs {
  version: string;
  necessary: true;
  analytics: boolean;
  marketing: boolean;
}

export function hasAnalyticsConsent(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const p = JSON.parse(raw) as CookiePrefs;
    return p.version === COOKIE_VERSION && p.analytics === true;
  } catch {
    return false;
  }
}

/** Načíta GA4 gtag.js a inicializuje meranie. Bezpečné volať opakovane. */
export function initGoogleAnalytics(): void {
  if (initialized || typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;

  // Načítaj gtag.js asynchrónne
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  // anonymize_ip — GDPR best practice; SPA: pageview posielame manuálne
  window.gtag('config', GA_ID, { anonymize_ip: true, send_page_view: false });
  window.gtag('event', 'page_view', {
    page_path: window.location.pathname + window.location.search,
  });
  initialized = true;
}

/** Track page_view pri SPA navigácii — len ak je analytics consent. */
export function gaPageView(): void {
  if (!hasAnalyticsConsent()) return;
  if (!initialized) {
    initGoogleAnalytics(); // prvé volanie po consente — inicializuj (pošle page_view samo)
    return;
  }
  window.gtag?.('event', 'page_view', {
    page_path: window.location.pathname + window.location.search,
  });
}
